import { render, staticRenderFns } from "./BlockLogs.vue?vue&type=template&id=193d7fc1&scoped=true"
import script from "@/components/request/RequestDetail/block-logs/BlockLogs.ts?vue&type=script&lang=ts&external"
export * from "@/components/request/RequestDetail/block-logs/BlockLogs.ts?vue&type=script&lang=ts&external"
import style0 from "@/components/request/RequestDetail/block-logs/block-logs.scss?vue&type=style&index=0&id=193d7fc1&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193d7fc1",
  null
  
)

export default component.exports